import * as React from 'react';
import { Icon, IIconStyles } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';

const styles: Partial<IIconStyles> = {
    root: {
        fontSize: 16,
        color: 'var(--card-secondaryText)',
    },
};

/** An icon, with the right proportion and color to be used as an asset image. */
export default observer(function AssetIcon({
    className,
    iconName,
    title,
}: {
    className?: string;
    iconName: string;
    title?: string;
}) {
    return <Icon className={className} styles={styles} iconName={iconName} title={title} />;
});
